import { Injectable } from "@angular/core";
import { map, Observable, Subject } from "rxjs";
import { NotificationApi } from "./notification.api";
import { MhNotification, MhNotificationSettings } from "./notification.types";

@Injectable({ providedIn: "root" })
export class NotificationService {
  private readonly removedNotificationSubject = new Subject<string>();
  readonly notificationRemoved$ = this.removedNotificationSubject.asObservable();

  constructor(private notificationApi: NotificationApi) {}

  removeNotification(id: string): void {
    this.removedNotificationSubject.next(id);
  }

  loadNotificationList(): Observable<Array<MhNotification>> {
    return this.notificationApi
      .loadNotificationList()
      .pipe(
        map((dtos) => dtos.sort((a, b) => b.createdAt - a.createdAt)),
      );
  }

  markReadNotifications(ids: Array<string>): Observable<boolean> {
    return this.notificationApi.markReadNotifications(ids);
  }

  loadNotificationSettings(): Observable<MhNotificationSettings> {
    return this.notificationApi.loadNotificationSettings();
  }

  saveNotificationSettings(settings: MhNotificationSettings): Observable<boolean> {
    return this.notificationApi.saveNotificationSettings(settings);
  }
}
